'use strict'
import { windowIsSmallerThan } from './helpers.js';
import { validateFormSubmit, validateInput, validateEmailInput } from './validation.js';

jQuery(document).ready(function ($) {    

    // Header Sticky
    $(this).scrollTop(0)
    $(window).scroll(function () {
        if ($(this).scrollTop() > 15) {
            $('header.site-header').addClass("is-sticky");
        } else {
            $('header.site-header').removeClass("is-sticky");
        } 
    }); 

    // check if site-header offset top is greater than 50
    if($('header.site-header').offset().top > 50) {
        $('header.site-header').addClass("is-sticky"); 
    }

    // Components Header — sticky offset + dropdown
    if ($('.components-header').length > 0) {
        const $componentsHeader = $('.components-header');
        const $nav = $componentsHeader.find('nav.wp-block-navigation'); 

        // Keep sticky top flush below the main site header
        function updateComponentsTop() {
            const siteHeaderH = $('header.site-header').outerHeight() || 0;
            const adminBar = $('#wpadminbar').outerHeight() || 0;
            $componentsHeader.css('top', siteHeaderH + adminBar + 'px');
        }
        updateComponentsTop();
        $(window).on('resize', updateComponentsTop);

        // Inject toggle button before the nav
        const $toggle = $(
            '<button class="components-header-toggle" aria-expanded="false">' +
            'Components' +
            '<span class="toggle-arrow">' +
            '<svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">' +
            '<path d="M2 4l4 4 4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
            '</svg></span></button>'
        );
        $nav.before($toggle);

        $toggle.on('click', function () {
            const opening = !$nav.hasClass('open');
            $toggle.toggleClass('open').attr('aria-expanded', opening);
            $nav.toggleClass('open');

            if(windowIsSmallerThan(767, ()=>{})){
                if(opening){
                    $("body").css("overflow", "hidden");
                }else{
                    $("body").css("overflow", "auto");
                }
            }
        });

        // Close on outside click
        $(document).on('click.componentsHeader', function (e) {
            if (!$(e.target).closest('.components-header').length) {
                $toggle.removeClass('open').attr('aria-expanded', 'false');
                $nav.removeClass('open');

                if(windowIsSmallerThan(767, ()=>{})){
                   $("body").css("overflow", "auto");
                }
            }
        });

        // Close after clicking a nav link (smooth scroll to section)
        $nav.on('click', 'a.wp-block-navigation-item__content', function () {
            const itemLabel = $(this).find(".wp-block-navigation-item__label").text();

            const listContainer = $(this).closest(".wp-block-navigation__container").find(".wp-block-navigation-item__content").removeClass("active");

            $(this).addClass("active");

            $(this).closest(".components-header").find(".components-header-toggle").empty();

            const headerToggle = $(this).closest(".components-header").find(".components-header-toggle").append(itemLabel + '<span class="toggle-arrow">' +
            '<svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">' +
            '<path d="M2 4l4 4 4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
            '</svg></span>');
            
            $toggle.removeClass('open').attr('aria-expanded', 'false');
            $nav.removeClass('open');

            if(windowIsSmallerThan(767, ()=>{})){
                $("body").css("overflow", "auto");
            }

        });
    }
    
    // Flight Widget 
    if( $('.flight-widget').length > 0 ) { 

         // Make it active on page load
    $('.flight-widget').addClass('active');
    
        // Open
        $('.flight-widget .search-btn-mobile .wp-block-button__link').on('click', function() {
            $(this).closest('.flight-widget').addClass('active');  
        });

        // Close
        $('.flight-widget .flight-widget-collapse').on('click', function() {
            $(this).closest('.flight-widget').removeClass('active'); 

        });
        
        // Close on outside click 
        $(document).on('click', function(event) {
            if (!$(event.target).closest('.flight-widget').length) {
                $('.flight-widget').removeClass('active'); 
            }
        });

    }

    $("#comments .comment-list").toggle();

    $("#comments .drop-down-comments").on('click', ()=>{
        $("#comments .comment-list").toggle({
            effect: "slide",
            easing: "linear", //swing
            duration: 400, 
        });
        $("#comments .drop-down-comments").toggleClass("active")
    })


    //Search results page load more ajax
    $(".search .load-more").on('click', function(){
        let button = $(this).closest(".wp-block-buttons");
        var page = button.data('page');
        var max = button.data('max');
        var query = button.data('query');
        const postsWrapper = $(".search .search-result-post-wrapper");
        const category =  postsWrapper.data("active-category");
        const order = $('.search-sort-filter-wrapper').attr('data-sort-filter');
    
        $('.search .search-result-post-wrapper').addClass('loading');

        $.ajax({
                url: genpro_obj.ajaxurl,
                type: 'POST',
                data: {
                    action: 'search_results_load_more',
                    page: page,
                    search: query,
                    category : category,
                    order: order
                },
                success: function(response) {
                     page  = page + 1 ;
                     
                    button.data('page', page);

                    if (response.data.end) {
                        button.hide();
                    }
                    $('.search .search-result-post-wrapper').append(response.data.html);
                    $('.search .search-result-post-wrapper').removeClass('loading');

                    
                   
                }
            });
        
    })

    // Sticky Related Stories (script-driven sticky)
    if ($('.sticky-related-posts').length) {
        const $win = $(window);

        function getHeaderOffset() {
            const $hdr = $('header.site-header.is-sticky');
            return $hdr.length ? $hdr.outerHeight() : 0;
        }

        function updateOne($sticky) {
            const topMargin = parseInt($sticky.attr('data-top'), 10) || 24;
            const headerH = getHeaderOffset();
            const fixedTop = headerH + topMargin;

            const $main = $('#main');
            const $mainAlt = $main.length ? $main : $('#primary .site-main');
            if (!$mainAlt.length) return; // no main content to constrain to

            const mainTop = $mainAlt.offset().top;
            const mainBottom = mainTop + $mainAlt.outerHeight();

            const startTop = $sticky.data('startTop') ?? $sticky.offset().top; // cache initial
            if ($sticky.data('startTop') == null) {
                $sticky.data('startTop', startTop);
            }

            const scrollTop = $win.scrollTop();
            const stickyHeight = $sticky.outerHeight(true);
            const currentWidth = $sticky.width();

            if (scrollTop + fixedTop >= startTop) {
                // Fix to viewport
                $sticky.addClass('is-fixed')
                    .css({ position: 'fixed', top: fixedTop + 'px', width: currentWidth });

                // Prevent layout jump
                const $parent = $sticky.parent();
                if (!$parent.data('minHeightSet')) {
                    $parent.css('min-height', stickyHeight);
                    $parent.data('minHeightSet', true);
                }

                // Stop at main bottom
                const bottomOverlap = (scrollTop + fixedTop + stickyHeight) - mainBottom;
                if (bottomOverlap > 0) {
                    $sticky.css({ transform: 'translateY(' + (-bottomOverlap) + 'px)' });
                } else {
                    $sticky.css({ transform: '' });
                }
            } else {
                // Reset
                $sticky.removeClass('is-fixed').css({ position: '', top: '', width: '', transform: '' });
                const $parent = $sticky.parent();
                if ($parent.data('minHeightSet')) {
                    $parent.css('min-height', '');
                    $parent.removeData('minHeightSet');
                }
            }
        }

        function onScrollOrResize() {
            // Disable on small screens where sidebar stacks under content
            if (window.matchMedia('(max-width: 768px)').matches) {
                $('.sticky-related-posts').each(function () {
                    $(this).removeClass('is-fixed').css({ position: '', top: '', width: '', transform: '' });
                    const $parent = $(this).parent();
                    if ($parent.data('minHeightSet')) {
                        $parent.css('min-height', '');
                        $parent.removeData('minHeightSet');
                    }
                });
                return;
            }
            $('.sticky-related-posts').each(function () { updateOne($(this)); });
        }

        // Initial measurements and handlers
        onScrollOrResize();
        let resizeTimer;
        $win.on('scroll', onScrollOrResize);
        $win.on('resize', function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function () {
                // Reset cached startTop as layout might change
                $('.sticky-related-posts').each(function () { $(this).removeData('startTop'); });
                onScrollOrResize();
            }, 100);
        });
    }

    if($('.search-filters').length > 0){
         $(".search-catogories-filter-wrapper .search-category-filter").on("click", function () {
            const categoryPill = $(this);
            const category = categoryPill.data("category");
            const postsWrapper = $(".search .search-result-post-wrapper");
            const activeCategory = postsWrapper.attr("data-active-category");

            if(category === activeCategory){
                return;
            }
            
            categoryPill.closest(".search-catogories-filter-wrapper").find(".search-category-filter").removeClass("active");
            categoryPill.addClass("active");

            const searchTerm = postsWrapper.data("search-term");

            postsWrapper.attr("data-active-category", category);

            postsWrapper.addClass('loading');

            let button = $('.load-more-wrapper')
            const order = $('.search-sort-filter-wrapper').attr('data-sort-filter');

            var container = $('.category-filters');
            var containerOffset = container.offset();
            var itemOffset = categoryPill.offset();
            var scrollLeft = container.scrollLeft();

            var offsetX = (itemOffset.left - containerOffset.left) + (categoryPill.outerWidth() / 2) - (container.width() / 2);

            container.animate({
                scrollLeft: scrollLeft + offsetX,
            }, 300);


            $.ajax({
                url : genpro_obj.ajaxurl,
                type : 'POST',
                data : { 
                    action : 'search_page_cat_filters',
                    category : category,
                    searchTerm : searchTerm,
                    order: order
                }, 
                success : function(response){
                    postsWrapper.html(response.data.html);
                    
                    postsWrapper.removeClass('loading');

                    button.data('page', 2);
                    button.attr('data-page', 2);
                    button.attr('data-max', response.data.max);
                    button.data('max', response.data.max);
                 
                    if (!response.data.end) {
                        button.hide(); 
                    }else{
                         button.show(); 
                    }
                }
            });
            
         });


         $(".search-sort-filter-wrapper .search-sort-filters").on("click", function () {
            $(this).toggleClass("active")
            $(this).children('li:not(.init)').toggleClass("show");
         })

        $(document).on('click', function(event) {
            if (!$(event.target).closest('.search-sort-filters').length) {
                $('.search-sort-filters').children('li:not(.init)').removeClass('show');
                    $('.search-sort-filters').removeClass('active');
            }
        });

        $(".search-sort-filter-wrapper .search-sort-filters li:not(.init)").on("click", function () {
            const currentSortOrder = $('.search-sort-filter-wrapper').attr('data-sort-filter');
            const order = $(this).data('value');

            if (currentSortOrder === order) {
                return;
            }

            var allOptions = $(".search-sort-filter-wrapper .search-sort-filters").children('li:not(.init)');
            const postsWrapper = $('.search-result-post-wrapper');
            allOptions.removeClass('selected');

            $(this).addClass('selected');

            const category = postsWrapper.attr("data-active-category");
            const searchTerm = postsWrapper.data('search-term');
            const postCount = postsWrapper.children().length;
            
            $('.search-sort-filter-wrapper').attr('data-sort-filter', order)

            $(".search-sort-filter-wrapper .search-sort-filters").children('.init').find('.init-text').html($(this).html());
            
            postsWrapper.addClass('loading');
            $.ajax({
                url : genpro_obj.ajaxurl,
                type : 'POST',
                data : { 
                    action : 'search_order_filters',
                    category : category,
                    searchTerm : searchTerm,
                    order: order,
                    postCount : postCount,
                }, 
                success : function(response){
                    postsWrapper.html(response.data.html);
                    
                    postsWrapper.removeClass('loading');

                }
            });


        })
    }

    if($('.post-filters').length > 0){

        $(".post-filters .category-filters .category-filter").on("click", function () {
            const categoryPill = $(this);
            const postsWrapper = $('.wp-block-wwx-advanced-query__posts.archive');

            const category = categoryPill.data("category");
            const subCategory = categoryPill.data("sub-category");
            const activeCategory = postsWrapper.attr("data-active-category");
            
            if(subCategory === activeCategory){
                return;
            }

            categoryPill.closest(".category-filters").find(".category-filter").removeClass("active");
            categoryPill.addClass("active");

            const order = $('.sort-filter-wrapper').attr('data-sort-filter');
            postsWrapper.attr("data-active-category", subCategory);

            postsWrapper.addClass('loading');

            var container = $('.category-filters');
            var containerOffset = container.offset();
            var itemOffset = categoryPill.offset();
            var scrollLeft = container.scrollLeft();

            var offsetX = (itemOffset.left - containerOffset.left) + (categoryPill.outerWidth() / 2) - (container.width() / 2);

            container.animate({
                scrollLeft: scrollLeft + offsetX,
            }, 300);

            $.ajax({
                url : genpro_obj.ajaxurl,
                type : 'POST',
                data : { 
                    action : 'cat_filters',
                    category : category,
                    sub_category : subCategory,
                    order: order
                }, 
                success : function(response){
                    postsWrapper.html(response.data.html);
                    postsWrapper.removeClass('loading');

                    // Ensure state is synced when returning to "All"
                    if (subCategory === 'all') {
                        postsWrapper.attr('data-active-category', 'all');
                        const $filters = $('.post-filters .category-filters');
                        $filters.find('.category-filter').removeClass('active');
                        $filters.find('.category-filter[data-sub-category="all"]').addClass('active');
                    }
                }
            });
        })

        $(".post-filters .sort-filters").on("click", function () {
            $(this).toggleClass("active")
            $(this).children('li:not(.init)').toggleClass("show");
        })

        $(document).on('click', function(event) {
            if (!$(event.target).closest('.sort-filters').length) {
                $('.sort-filters').children('li:not(.init)').removeClass('show');
                    $('.sort-filters').removeClass('active');
            }
        });

        $(".post-filters .sort-filters li:not(.init)").on("click", function () {
            const currentSortOrder = $('.sort-filter-wrapper').attr('data-sort-filter');
            const order = $(this).data('value');

            if(currentSortOrder === order){
                return;
            }
            


            var allOptions = $(".post-filters .sort-filters").children('li:not(.init)');
            const postsWrapper = $('.wp-block-wwx-advanced-query__posts.archive');
            allOptions.removeClass('selected');

            $(this).addClass('selected');

            $(".post-filters .sort-filters").children('.init').find('.init-text').html($(this).html());

            const category = $('.category-filters .category-filter').attr('data-category');
            const subCategory = postsWrapper.attr("data-active-category");
            const postCount = postsWrapper.children().length;
            
            $('.sort-filter-wrapper').attr('data-sort-filter', order)

            postsWrapper.addClass('loading');

            $.ajax({
                url : genpro_obj.ajaxurl,
                type : 'POST',
                data : { 
                    action : 'order_filters',
                    category : category,
                    sub_category : subCategory,
                    order: order,
                    postCount : postCount,
                }, 
                success : function(response){
                    postsWrapper.html(response.data.html);
                    
                    postsWrapper.removeClass('loading');

                }
            });

            

        })
    }


    if($('.single-post-share').length > 0){
        $(".share-icon").on("click", function () {
            $(this).closest('.share-wrapper').find('.share-social-icons').toggleClass('active')
        })

         $(document).on('click', function(event) {
            if (!$(event.target).closest(".share-icon").length) {
                $('.share-social-icons').removeClass('active');
            }
        });
    }


    if($('.category-pills-wrapper').length > 0){
            $(".category-pills-wrapper .category-pill").on("click", function () {
            const categoryPillWrapper = $('.category-pills-wrapper');
            const categoryPill = $(this);
            
            const category = categoryPill.data("category");
            const activeCategory = categoryPillWrapper.attr("data-active-category");
        
            if(category === activeCategory){
                return;
            }
            categoryPillWrapper.find('.category-pill').removeClass('active');
            categoryPill.addClass('active');
            categoryPillWrapper.attr("data-active-category", category)

            // Center the active pill
            centerActivePill(categoryPillWrapper, categoryPill);

            const postsWrapper = $('.wp-block-wwx-featured-home-wrapper');
            postsWrapper.addClass('loading');
            $.ajax({
                url : genpro_obj.ajaxurl,
                type : 'POST',
                data : { 
                    action : 'home_category_tabs', 
                    category : category,
                }, 
                success : function(response){
                    postsWrapper.html(response.data.html);
                    postsWrapper.removeClass('loading');
                }
            });
            });

            // Function to center the active pill
            function centerActivePill(container, activeItem) {
                var containerOffset = container.offset();
                var itemOffset = activeItem.offset();
                var scrollLeft = container.scrollLeft();
                
                // Calculate the offset to center the item
                var offsetX = (itemOffset.left - containerOffset.left) + (activeItem.outerWidth() / 2) - (container.width() / 2);
                
                container.animate({
                    scrollLeft: scrollLeft + offsetX,
                }, 300);
            }

            // Center the initial active pill on page load
            $(document).ready(function() {
                const initialActive = $('.category-pills-wrapper .category-pill.active');
                if (initialActive.length > 0) {
                    setTimeout(function() {
                        centerActivePill($('.category-pills-wrapper'), initialActive);
                    }, 100); // Small delay to ensure DOM is fully rendered
                }
            });
    }


    if($('.load-more-destinations')){
            $(".load-more-destinations").on("click", function () {
            var button = $(this).closest('.load-more-wrapper');
            var page = button.attr('data-page');
            const maxPages = button.attr('data-max');
            const postsWrapper = $('.related-posts-wrapper');
            const categories = postsWrapper.attr('data-categories');

            $('.related-posts').addClass('loading')


            $.ajax({
            url : genpro_obj.ajaxurl,
            type : 'POST',
            data : { 
                action : 'destinations_post_grid_load_more',
                categories : categories.replace(/\s+/g, ''),
                page : page,
            }, 
            success : function(response){
                $('.related-posts').append(response.data.html);
                $('.related-posts').removeClass('loading')

                page++;
                button.attr('data-page', page);

                if(page > maxPages){
                    button.hide();
                }
            }
        });

        
            
            })
    }

    if($('#footer-widgets')) {

        // Footer Accordion Functionality
        function initFooterAccordions() {
            const $footerWidgets = $('.footer-widget-1, .footer-widget-2, .footer-widget-3, .footer-widget-4');
            
            // Check if we're on mobile (768px and below)
            function isMobile() {
                return $(window).width() <= 768;
            }
            
            // Initialize accordion behavior
            function setupAccordions() {
                if (isMobile()) {
                    // Mobile: Convert to accordions
                    $footerWidgets.each(function() {
                        const $widget = $(this);
                        const $aside = $widget.find('aside');
                        const $title = $aside.find('.widget-title');
                        const $menuContainer = $aside.find('.menu-plan-your-trip-container, .menu-partners-container, .menu-need-help-container, .menu-travellab-group-container');
                        
                        // Add accordion classes
                        $widget.addClass('footer-accordion');
                        $title.addClass('accordion-trigger');
                        $menuContainer.addClass('accordion-content');
                        
                        
                        // Add click handler to title
                        $title.off('click.accordion').on('click.accordion', function() {
                            const $this = $(this);
                        
                            const isOpen = $this.closest(".footer-accordion").hasClass("active");
                            
                            // Toggle current accordion
                            if (isOpen) {
                                $this.closest(".footer-accordion").removeClass("active");
                            } else {
                                $this.closest(".footer-accordion").addClass("active");
                            }
                        });
                        
                        // Add cursor pointer to title
                        $title.css('cursor', 'pointer');
                    });
                } else {
                    // Desktop: Remove accordion behavior
                    $footerWidgets.each(function() {
                        const $widget = $(this);
                        const $aside = $widget.find('aside');
                        const $title = $aside.find('.widget-title');
                        const $menuContainer = $aside.find('.menu-plan-your-trip-container, .menu-partners-container, .menu-need-help-container, .menu-travellab-group-container');
                        
                        // Remove accordion classes
                        $widget.removeClass('footer-accordion');
                        $title.removeClass('accordion-trigger active');
                        $menuContainer.removeClass('accordion-content');
                        
                        // Show all content and remove handlers
                        $menuContainer.show().removeAttr('style');
                        $title.off('click.accordion').css('cursor', 'auto');
                    });
                }
            }
            
            // Initialize on page load
            setupAccordions();
            
            // Re-initialize on window resize with debouncing
            let resizeTimer;
            $(window).on('resize', function() {
                clearTimeout(resizeTimer);
                resizeTimer = setTimeout(function() {
                    setupAccordions();
                }, 250);
            });
        }
        
        // Initialize footer accordions
        initFooterAccordions();
    }

    if($('.fare-categories').length > 0 || $('.fare-cards-container').length > 0){
        $('.fare-categories .fare-category').on("click", function(){
            let categoryPill = $(this);
            let activeCategory = categoryPill.closest('.fare-cards-wrapper').find('.fare-cards-container-outer').attr('data-active-category')
            let tripCount = categoryPill.closest('.fare-cards-wrapper').find('.fare-cards-container').attr('data-trip-count')
            let cabin = categoryPill.closest('.fare-cards-wrapper').find('.fare-cards-container').attr('data-cabin');
            let routes = categoryPill.closest('.fare-cards-wrapper').find('.fare-cards-container').attr('data-routes');
            let airlineCode = categoryPill.closest('.fare-cards-wrapper').find('.fare-cards-container').attr('data-airline-code');
            let regionality = categoryPill.closest('.fare-cards-wrapper').find('.fare-cards-container').attr('data-regionality');
            let destination = categoryPill.closest('.fare-cards-wrapper').find('.fare-cards-container').attr('data-destination');
            let departure = categoryPill.closest('.fare-cards-wrapper').find('.fare-cards-container').attr('data-departure');
            let departureCountry = categoryPill.closest('.fare-cards-wrapper').find('.fare-cards-container').attr('data-departure-country');
            let destinationCountry = categoryPill.closest('.fare-cards-wrapper').find('.fare-cards-container').attr('data-destination-country');

            let departureType = categoryPill.closest('.fare-cards-wrapper').find('.fare-cards-container').attr('data-departure-type');
            let destinationType = categoryPill.closest('.fare-cards-wrapper').find('.fare-cards-container').attr('data-destination-type');


            let upperBound = categoryPill.closest('.fare-cards-wrapper').find('.fare-cards-container').attr('data-upper-bound');
            let lowerBound = categoryPill.closest('.fare-cards-wrapper').find('.fare-cards-container').attr('data-lower-bound');


            let category = categoryPill.attr('data-category')

            if(activeCategory === category) return;
            let fareCardsContainer = categoryPill.closest('.fare-cards-wrapper').find('.fare-cards-container');
            let fareCardsContainerOuter = categoryPill.closest('.fare-cards-wrapper').find('.fare-cards-container-outer');
            let categoriesContainer = categoryPill.closest('.fare-cards-wrapper').find('.fare-categories');
            let isCalendar = fareCardsContainerOuter.attr("data-calendar");
            let sortBy = fareCardsContainerOuter.attr("data-sort-by");
            fareCardsContainerOuter.addClass('loading');
            categoriesContainer.addClass('loading');

            categoryPill.closest('.fare-cards-wrapper').find('.fare-cards-container-outer').attr('data-active-category', category);

            
            categoryPill.closest('.fare-cards-wrapper').find('.fare-categories .fare-category').removeClass('active');
            categoryPill.addClass('active')

            //Added to check for Google tag manager tags in URL and pass through to ajax function
            const params = new URLSearchParams(window.location.search);
            const utms = {};
            params.forEach((value, key) => {
                utms[key] = value;
            });

            $.ajax({
                url: genpro_obj.ajaxurl,
                type: 'POST',
                data: {
                    action: 'flight_deals_category',
                    category : category,
                    tripCount : tripCount,
                    destination : destination,
                    departure : departure,
                    cabin : cabin, 
                    routes : routes,
                    airlineCode : airlineCode,
                    departureCountry : departureCountry,
                    destinationCountry : destinationCountry,
                    departureType : departureType,
                    destinationType : destinationType,
                    regionality : regionality,
                    isCalendar : isCalendar,
                    sortBy: sortBy,
                    lowerBound : lowerBound,
                    upperBound : upperBound,
                    ...utms
                },
                success: function(response) {
                    let previousCount = fareCardsContainer.find('.fare-card').length;

                    fareCardsContainer.html(response.data.html);
                    fareCardsContainerOuter.removeClass('loading');
                    categoriesContainer.removeClass('loading');

                    let newCount = fareCardsContainer.find('.fare-card').length;

                    // Reset trip count to what was just loaded
                    fareCardsContainer.attr('data-trip-count', newCount);

                    let loadMoreBtn = categoryPill.closest('.fare-cards-wrapper').find('.fare-cards-container-load-more');

                    // Show button if new category returned a full set, hide if it returned less
                    if(newCount < parseInt(tripCount)){
                        loadMoreBtn.hide();
                    } else {
                        loadMoreBtn.show();
                    }
                }
            });
        })
    }

    if($('.fare-cards-container-load-more').length > 0){
    $('.fare-cards-container-load-more').on("click", function(){

        let loadMoreCount = $(this).attr('data-trip-load-more-amount');
        let activeCategory = $(this).closest('.fare-cards-wrapper').find('.fare-cards-container-outer').attr('data-active-category')
        let tripCount = $(this).closest('.fare-cards-wrapper').find('.fare-cards-container').attr('data-trip-count');
        let destination = $(this).closest('.fare-cards-wrapper').find('.fare-cards-container').attr('data-destination');
        let departure = $(this).closest('.fare-cards-wrapper').find('.fare-cards-container').attr('data-departure');
        let departureCountry = $(this).closest('.fare-cards-wrapper').find('.fare-cards-container').attr('data-departure-country');
        let destinationCountry = $(this).closest('.fare-cards-wrapper').find('.fare-cards-container').attr('data-destination-country');
        let departureType = $(this).closest('.fare-cards-wrapper').find('.fare-cards-container').attr('data-departure-type');
        let destinationType = $(this).closest('.fare-cards-wrapper').find('.fare-cards-container').attr('data-destination-type');
        let fareCardsContainer = $(this).closest('.fare-cards-wrapper').find('.fare-cards-container');
        let cabin = $(this).closest('.fare-cards-wrapper').find('.fare-cards-container').attr('data-cabin');
        let routes = $(this).closest('.fare-cards-wrapper').find('.fare-cards-container').attr('data-routes');
        let airlineCode = $(this).closest('.fare-cards-wrapper').find('.fare-cards-container').attr('data-airline-code');
        let regionality = $(this).closest('.fare-cards-wrapper').find('.fare-cards-container').attr('data-regionality');
        let fareCardsContainerOuter = $(this).closest('.fare-cards-wrapper').find('.fare-cards-container-outer');
        let isCalendar = fareCardsContainerOuter.attr("data-calendar");
        let sortBy = fareCardsContainerOuter.attr("data-sort-by");

        let upperBound = $(this).closest('.fare-cards-wrapper').find('.fare-cards-container').attr('data-upper-bound');
        let lowerBound = $(this).closest('.fare-cards-wrapper').find('.fare-cards-container').attr('data-lower-bound');


        let tripCardsAmount = parseInt(tripCount) + parseInt(loadMoreCount);

        $(this).closest('.fare-cards-wrapper').find('.fare-cards-container').attr('data-trip-count', tripCardsAmount);

        fareCardsContainerOuter.addClass('loading');

        $(this).find('.wp-block-button').addClass('disabled');
        $(this).css('pointer-events', 'none');

        if($(this).closest('.fare-cards-wrapper').find('.fare-categories').length > 0){
            $(this).closest('.fare-cards-wrapper').find('.fare-categories').addClass('loading');
        }

        //Added to check for Google tag manager tags in URL and pass through to ajax function
        const params = new URLSearchParams(window.location.search);
        const utms = {};
        params.forEach((value, key) => {
            utms[key] = value;
        });

        $.ajax({
            url: genpro_obj.ajaxurl,
            type: 'POST',
            data: {
                action: 'flight_deals_category',
                category : activeCategory,
                tripCount : tripCardsAmount,
                destination : destination,
                departure : departure,
                cabin : cabin,
                routes : routes,
                airlineCode : airlineCode,
                departureCountry : departureCountry,
                destinationCountry : destinationCountry,
                departureType : departureType,
                destinationType : destinationType,
                regionality : regionality,
                isCalendar: isCalendar,
                sortBy: sortBy,
                lowerBound : lowerBound,
                upperBound : upperBound,
                ...utms
            },
            success: function(response) {
                $(".fare-cards-container-load-more").find('.wp-block-button').removeClass('disabled');
                $(".fare-cards-container-load-more").css('pointer-events', 'auto');

                if($('.fare-categories').length > 0){
                    $('.fare-categories').removeClass('loading');
                }

                let previousCount = fareCardsContainer.find('.fare-card').length;

                fareCardsContainer.html(response.data.html);
                fareCardsContainerOuter.removeClass('loading');

                let newCount = fareCardsContainer.find('.fare-card').length;

                // Only hide if no new cards were added (we've hit the end)
                if(newCount <= previousCount){
                    fareCardsContainerOuter.closest('.fare-cards-wrapper')
                        .find('.fare-cards-container-load-more').hide();
                }
            }
        });
        
    })

    }

    if ($('form[name="newsletter_sign_up"]').length) {
        const selectors = [
            '.newsletter-sign-up-banner form[name="newsletter_sign_up"]',
            '.newsletter-sign-up-form-popup form[name="newsletter_sign_up"]'
        ];

         selectors.forEach(sel => {
            const form = $(sel);
            form.find('input[required]').on('change', validateInput);
            form.find('input[type="email"]').on('change', validateEmailInput);
            form.find('button[type="submit"]').on('click', () => validateFormSubmit(sel));
        });

        $('form[name="newsletter_sign_up"]').on('submit', function (e) {
            e.preventDefault();

            const form = $(this);
            form.find(".form-message").fadeOut();
            const email = form.find('input[name="email"]').val();
            const name = form.find('input[name="name"]').val();
            const formInputs = form.find('input[type="submit"], button[type="submit"], input[type="text"], input[type="email"]');
            form.find('button[type="submit"]').after('<span class="btn-spinner"></span>');
            
            let subscribeSignupType = "CMS Footer";
            let signupMedium  = "embeddedNew";
            let signupPage  = "newLandingPage";
            let signUpSource = "webform";
            
            if (form.closest('.newsletter-sign-up-form-popup').length) {
                subscribeSignupType = "CMS NewsLetter Popup";
                signupMedium = "popup";
            }
            
            // loading state
            formInputs.prop('disabled', true).css({ opacity: '0.6', cursor: 'not-allowed' });


            const formData = new FormData();
            formData.append('email', email);
            formData.append('firstName', name);
            formData.append('signup_page', window.location.pathname);
            formData.append('signupPage', signupPage);
            formData.append('signupMedium', signupMedium);
            formData.append('signUpSource', signUpSource);
            
            function resetBtn() {
                formInputs.prop('disabled', false).css({ opacity: '1', cursor: 'pointer' });
                form.find('.btn-spinner').remove();
            }
            
            fetch(form.attr('action'), {
                method: 'POST',
                body: formData,
                mode: 'no-cors'
            })
            .then(function () {
                resetBtn();

                 form.find('input[name="name"], input[name="email"]').val('');
                 showMessage(form, "success", "Thank you for subscribing to our newsletter")

                try {
                    if (window.dataLayer) {
                        window.dataLayer.push({
                            event: 'newsletterSubscribe',
                            email: email,
                            firstName: name,
                            subscribeSignupType: subscribeSignupType,
                            campaignType: window.location.pathname,
                            signupMedium : signupMedium,
                            signupPage : signupPage
                        });
                    }
                } catch (err) {
                    console.warn('GTM push failed', err);
                }
            })
            .catch(function (e) {
                resetBtn();
                showMessage(form, "error", "Something went wrong ,please try again")

                try {
                    if (window.dataLayer) {
                        window.dataLayer.push({
                            event: 'newsletterSubscribeFailed',
                            email: email,
                            signupMedium : signupMedium,
                            signupPage : signupPage
                        });
                    }
                } catch (err) {
                    console.warn('GTM push failed', err);
                }
            });
        });

        function showMessage(form, type, formMessage){
            const message = form.find(".form-message");
            message.text(`${formMessage}`);
            message.addClass(type);
            message.css('opacity', 0).show().animate({ opacity: 1 }, 400);
            if (type === "success") {
                setTimeout(function() {
                    message.animate({ opacity: 0 }, 600, function() {
                        message.removeClass(type);
                    });
                }, 5000);
            }
        }
    }

    if ($('.birthday-banner').length > 0) {
        $('.birthday-banner').each(function () {
            const $banner = $(this);
            const $mouseIcon = $banner.find('.mouse-icon').first();

            if (!$mouseIcon.length) {
                return;
            }

            let origin = null;
            let frameRequest = null;

            function setOrigin() {
                const bannerRect = $banner[0].getBoundingClientRect();
                const iconRect = $mouseIcon[0].getBoundingClientRect();

                origin = {
                    x: (iconRect.left - bannerRect.left) + (iconRect.width / 2),
                    y: (iconRect.top - bannerRect.top) + (iconRect.height / 2)
                };
            }

            function moveIcon(event) {
                if (!origin) {
                    setOrigin();
                }

                const bannerRect = $banner[0].getBoundingClientRect();
                const mouseX = event.clientX - bannerRect.left;
                const mouseY = event.clientY - bannerRect.top;
                const moveX = mouseX - origin.x;
                const moveY = mouseY - origin.y;

                $mouseIcon.css('transform', 'translate3d(' + moveX + 'px, ' + moveY + 'px, 0)');
            }

            $banner.on('mouseenter', function (event) {
                setOrigin();

                $mouseIcon.addClass('is-following');

                if (event && typeof event.clientX === 'number') {
                    moveIcon(event);
                }
            });

            $banner.on('mousemove', function (event) {
                if (frameRequest) {
                    cancelAnimationFrame(frameRequest);
                }

                frameRequest = requestAnimationFrame(function () {
                    moveIcon(event);
                    frameRequest = null;
                });
            });

            $banner.on('mouseleave', function () {
                if (frameRequest) {
                    cancelAnimationFrame(frameRequest);
                    frameRequest = null;
                }

                origin = null;
                $mouseIcon.removeClass('is-following');
                $mouseIcon.css('transform', 'translate3d(0, 0, 0)');
            });
        });
    }

    if ($("form.wpcf7-form").length > 0) {
        let dateInput = $("form.wpcf7-form").find('input[type="date"]');
        if (dateInput.length > 0) {
            dateInput.on('click focus', function () {
                try {       
                    this.showPicker();
                } catch (error) {
                }
            });
        }
    }

})

